import { makeStyles } from "@material-ui/styles";
import { theme } from "./theme";
import { descriptionText, link } from "./sharedStyles";

export const useStyles = makeStyles({
  container: {
    padding: "1rem 0 0 1.56rem",
  },
  description: {
    ...descriptionText,
    maxWidth: "760px",
    marginBottom: "1rem",
  },
  footer: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    marginTop: "0.5rem",
  },
  helpLinkContainer: {
    marginBottom: "1rem",
  },
  helpIcon: {
    color: theme.text.primary,
    fontSize: theme.fontSizes.xs,
  },
  alertContainer: {
    marginTop: "1.5rem",
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "column",
  },
  checkboxWrapper: {
    display: "flex",
    alignItems: "center",
  },
  labelTermos: {
    fontSize: theme.fontSizes.md,
    color: theme.text.primary,
  },
  link: { ...link },
});
